<template>
  <modal
      v-if="modalConfirmarEmail"
      size="medium"
      :has-footer="false"
      @close="toggleModalConfirmarEmail"
  >
    <div slot="header">
      <p class="Modal__title">Você ainda não confirmou seu e-mail</p>
      <p class="">{{ usuario.email }} <a class="Modal__subtitle" :href="linkAlterarEmail" @click.prevent="abrirPaginaEmail">Alterar e-mail!</a></p>
    </div>
    <div slot="content">
      <section class="Confirmar__link has-text-centered">
        <a @click.prevent="reenviarEmailConfirmacao">Clique aqui para receber o e-mail de confirmação!</a>
      </section>

      <section class="Modal__sectionContent">
        <p>Para confirmar, basta abrir o e-mail que enviamos para você e clicar no link.<br> Se não recebeu esse e-mail, entre em <a :href="linkContato">contato</a> conosco.</p>
      </section>

      <section class="Modal__sectionContent">
        <p>Se você não confirmar seu e-mail, não poderá:</p>
        <ul>
          <li>Receber notificações de seus monitoramentos por e-mail.</li>
          <li>Realizar uma assinatura de algum plano.</li>
          <li>Baixar PDFs dos Diários Oficiais.</li>
        </ul>
      </section>
    </div>
  </modal>
</template>

<script>
import Modal from '../../components/monitoramentos/Modal';
import * as types from './../../store/mutation-types';
import * as modals from './../../store/modal-types';
import usuarioApi from '../../api/usuario';
import { subdomainUrl , url} from '../../utils/url';
export default {
  components: {
    Modal,
  },
  props: {
    email: {
      default: '',
      type: String
    },
    loading: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {

    }
  },
  computed: {
    modalConfirmarEmail() {
      return this.$store.state.modals.confirmarEmail;
    },
    usuario() {
      return this.$store.state.usuario.user;
    },
    getEmail() {
      return this.usuario.email || this.email || '';
    },
    linkAlterarEmail() {
      if (window.location.host.startsWith('monitoramentos')) {
        return subdomainUrl('monitoramentos', '/email');
      }
      return url('configuracoes/dados-pessoais')
    },
    linkContato() {
      return `${process.env.MIX_BASE_URL}/fale-conosco`
    }
  },
  methods: {
    toggleModalConfirmarEmail() {
      this.$store.commit(types.TOGGLE_MODAL, modals.CONFIRMAR_EMAIL);
    },
    abrirPaginaEmail() {
      // vamos verificar se tem $route, pois quando está usando
      // o componente na "parte pública" do site não tem
      if (this.$route) {
        // se já estiver na pagina de email fecha os modais
        if (this.$route.name === 'email') {
          // fecha o modal da assinatura e o de confirmar email
          EventBus.$emit('modal-close');
        }

        // se landing page, vamos redirecionar para a página de email
        if (this.$route.name === 'home') {
          EventBus.$emit('loading-show');
          window.location = '/email';
          return;
        }

        // atualiza a rota
        this.$router.push({ name: 'email' });
        this.toggleModalConfirmarEmail();
      }

      window.location = this.linkAlterarEmail;
    },
    reenviarEmailConfirmacao() {
      usuarioApi.reenviarEmailConfirmacao({reenviado: true}, this.loading)
        .then(() => {
          this.$store.dispatch('showLoadingMessage', {
            message: `E-mail enviado para ${this.getEmail}.<br> Verifique seu e-mail!`,
            type: 'done',
          });

          this.toggleModalConfirmarEmail();
        });
    },
  },
};
</script>

<style lang="stylus" src="./modal-monitoramentos.styl"></style>

<style lang="stylus" scoped>
  p
    margin 0
  ul
    margin 0
    padding 0
    list-style none
  .Confirmar__link
    font-size 1.3rem
    font-weight 600
  .Modal__content li:before
    content '- '
  .Modal__sectionContent
    margin 1.5rem
  a
    color rgb(35, 147, 174)
    cursor pointer
    &:hover
      color darken(rgb(35, 147, 174), 5)
  .has-text-centered
    text-align center !important
</style>

<style lang="stylus">
  .bar-options
    user-select auto
    cursor auto
</style>
